<template>
    <div >
        <template  v-if="activeMode == 'list'">
            <b-list-group class=" rounded-0" flush>
                <b-list-group-item  class="d-flex p-0 align-items-start rounded-0 pt-2 pb-1" :class="{'border-0': layout == 'textNoWarp'}" v-for="(item,index) in listData"  v-if="listData.length > 0" @click="onListItem(item,index)">
                    <template v-if="layout == 'imgMixText'">
                        <div class="w-25 pr-2" v-if="showImg && item[colsMaps.img]">
                            <b-img left class="bg-gray" :src="hostPath + `/file/download?fileNo=${item[colsMaps.img]}`" fluid alt=""></b-img>
                        </div>
                        <div class="flex-fill w-75">
                            <div class="d-flex w-100 justify-content-between">
                                <h6 class="mb-1 text-left text-primary font-weight-bold">
                                    <b-badge variant="warning" v-if="item.attribute && item.attribute.indexOf('置顶') !== -1"><b-icon-capslock-fill></b-icon-capslock-fill>Top</b-badge>
                                    <b-badge variant="success" class="ml-1" v-if="item.attribute && item.attribute.indexOf('推荐') !== -1"><b-icon-hand-thumbs-up></b-icon-hand-thumbs-up>推荐</b-badge>
                                    
                                {{item[colsMaps.title]}}</h6>
                            </div>
                            <!-- <div class="d-flex w-100 text-dark justify-content-between font-weight-bold">
                                {{ new Date(item[colsMaps.date]).toLocaleDateString() }}
                            </div> -->
                            <p class="mb-1 text-left text-wrap text-secondary  text-truncate" style="display: block;line-height:1.2rem;max-height:2.4rem;overflow: hidden;">
                                {{item[colsMaps.subTitle]}}
                            </p>
                            <div class="d-flex w-100 justify-content-between">
                                <div class="text-dark font-weight-bold">
                                    {{ new Date(item[colsMaps.date]).toLocaleDateString() }}
                                </div>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-square-fill" viewBox="0 0 16 16">
        <path d="M0 14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12zm4.5-6.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5a.5.5 0 0 1 0-1z"/>
        </svg>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="layout == 'textNoWarp'">
                        <div class="flex-fill w-100">
                            <div class="d-flex d-flex-row w-100 justify-content-between pt-2 pb-2 pl-1 pr-1">
                                <div class="flex-fill text-nowrap text-truncate inline-block text-left text-dark font-weight-bold">
                                    <b-badge variant="warning" v-if="item.attribute && item.attribute.indexOf('置顶') !== -1"><b-icon-capslock-fill></b-icon-capslock-fill>Top</b-badge>
                                    <b-badge variant="success" class="ml-1" v-if="item.attribute && item.attribute.indexOf('推荐') !== -1"><b-icon-hand-thumbs-up></b-icon-hand-thumbs-up>推荐</b-badge>
                                    
                                    {{item[colsMaps.title]}}
                                </div>
                                <div class="text-right text-lightgray  font-weight-bold" style="width: 6rem;">
                                    {{ new Date(item[colsMaps.date]).toLocaleDateString() }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="layout == 'download'">
                        <div class="flex-fill w-100">
                            <div class="d-flex d-flex-row w-100 justify-content-between pt-2 pb-2 pl-1 pr-1">
                                <div class="flex-fill text-nowrap text-truncate inline-block text-left text-dark font-weight-bold">
                                   [附件] {{item[colsMaps.title]}}
                                </div>
                                <div class="text-right text-lightgray  font-weight-bold" style="width: 6rem;">
                                    {{ new Date(item[colsMaps.date]).toLocaleDateString() }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="layout == 'textAndNo'">
                        <div class="flex-fill w-100">
                            <div class="d-flex d-flex-row w-100 justify-content-between pt-2 pb-2 pl-1 pr-1">
                                <div class="flex-fill text-nowrap text-truncate inline-block text-left text-dark font-weight-bold">
                                    <b-badge  variant="primary">{{index + 1}}</b-badge>
                                    <b-badge variant="warning" v-if="item.attribute && item.attribute.indexOf('置顶') !== -1"><b-icon-capslock-fill></b-icon-capslock-fill>Top</b-badge>
                                    <b-badge variant="success" class="ml-1" v-if="item.attribute && item.attribute.indexOf('推荐') !== -1"><b-icon-hand-thumbs-up></b-icon-hand-thumbs-up>推荐</b-badge>
                                    
                                    {{item[colsMaps.title]}}
                                </div>
                                <div class="text-right text-lightgray  font-weight-bold" style="width: 6rem;">
                                    {{ new Date(item[colsMaps.date]).toLocaleDateString() }}
                                </div>
                            </div>
                        </div>
                    </template>
                </b-list-group-item>
                <b-list-group-item    class="d-flex p-0 align-items-start rounded-0 pt-1 pb-1" :class="{'border-0': layout == 'textNoWarp'}" v-if="listData.length == 0">
                    
                        <none :title="noneText"></none>
                </b-list-group-item>
            </b-list-group>
            <div class="d-flex justify-content-center" v-if="pagination && listData.length > 0">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="total"
                    :per-page="perPage"
                    first-number
                ></b-pagination>
            </div>
        </template>
        <template  v-if="activeMode == 'detail'">
            <detail :initData="activeData" :colsMaps="{
                    title:'title',
                    date:'create_time',
                    subTitle:'subTitle',
                    hot:true,
                    img:'',
                    content:'content',
                    user:'author_nickname',
                    sign:'source'
                }"></detail>
                <!-- <div class="d-flex justify-content-between p-2 text-primary">
                    <div @click="toList">
                        <b-icon-text-indent-right></b-icon-text-indent-right>返回列表
                    </div>
                    <div v-if="(activeIndex + 1)  < listData.length" class="d-flex" @click="nextItem">
                        下一篇《<div style="max-width: 18rem;" class="text-nowrap text-truncate">
                            {{listData[activeIndex + 1][colsMaps['title']]}}
                        </div>》
                        
                    </div>
                </div> -->
        </template>
        
    </div>
    
        
    
  </template>
  
  <script>
  
import store from '@/store'

import banner from '@/assets/banner1.png'

import none from '@/components/none.vue'
import detail from '@/components/detail.vue'
import { getContent } from '@/api/api.js'
  export default {
    name: 'list',
    components:{none,detail},
    props: {
        activeNav:{
            type:Object,
            default(){
                return null
            }
        },
        showImg:{
            type:Boolean,
            default: true
        },
        pagination:{
            type:Boolean,
            default: true
        },
        layoutNo:{
            type:String,
            default: ''
        },
        cols:{
            type:Array,
            default(){
                return ['*']
            }
        },
        initLayout:{
            type:String,
            default: 'imgMixText'  // imgMixText 左图右文  textMixImg  左文右图  textNoWarp 单行文字 textLayout    纯文字
        },
        rowspan:{
            type:[String,Number],
            default: 10  // 跨行
        },
        colsMaps:{
            type:Object,
            default(){
                return {title:'title',subTitle:'summary',img:'thn_img', date:'create_time'}
            }
        },
        showDetail:{
            type:Boolean,
            default: false
        },
        dataAllChildren:{
            type:Boolean,
            default: true
        },
        initRequest:{
            type:Object,
            default(){
                return null
            }
        },
        noneText:{
            type:String,
            default: '暂无内容,敬请关注'
        }
    },
    computed:{
        hostPath(){
            let config = this.webConfig
            let hostPath = `${config.protocol}://${config.host}${config.port?':'+config.port:''}${config.prefix}`
            // if(process.env.NODE_ENV === 'development'){
            //     hostPath =  config.prefix
            // }else{
            //     hostPath = `${config.protocol}://${config.host}${config.port?':'+config.port:''}${config.prefix}`
            // }
            return hostPath
        },
        layout(){
            let layout = ''
            
            if(this.initLayout){
                layout = this.initLayout
            }
            if(this.loadLayout){
                layout = this.loadLayout
            }
            return layout
        },
        config(){
            let config = this.webConfig
            return config
        },
        
        items(){
            let items = []
            let paths = this.paths
            if(Array.isArray(paths)){
                items = paths.map(item => item)
            }
            return items
        },
        style(){
            let style = {'width':'220px'}
            let width = this.width
            if(width){
                style['width'] = `${width}px`
            }
            return style
        },
        no(){
             let no = this.layoutNo
             if(!no && this.routeParams && this.routeParams.activeNo){
                no = this.routeParams.activeNo
             }

             return no

        },
        rootNavbar(){
            let bar = null

            bar = store.getters.getActiveNav
            return bar
        }
    },
    mounted(){
        if(this.$route.params.layout){
            this.loadLayout = this.$route.params.layout
        }
        if(this.layoutNo){
            this.getListData()
        }else if(this.$route.params.no){
            this.$set(this,'routeParams',this.$route.params)
            this.getListData()
        }else if(this.initRequest){
            this.getListData()
        }
        
        
    },
    data() {
      return {
        routeParams:null,
        listData:[],
        rows: 100,
        perPage: this.rowspan,
        currentPage: 1,
        total:0,
        activeMode:'list',
        activeData:null,
        activeIndex:null,
        loadLayout:''
      }
    },
      methods: {
        nextItem(){
            let index = this.activeIndex + 1
            let item = this.listData[index]
            if(this.showDetail){
                this.$set(this,'activeMode','detail')
                this.$set(this,'activeData',item)
                this.$set(this,'activeIndex',index)
                this.rootScrollToTop()
            }
            
            console.log(item)
            this.$emit('on-item-change',item)
        },
        toList(){
            if(this.showDetail){
                this.$set(this,'activeMode','list')
                this.$set(this,'activeData',null)
                this.$set(this,'activeIndex',null)
                this.rootScrollToTop()
            } 
        },
        onListItem(e,index){
            // if(this.showDetail){
            //     this.$set(this,'activeMode','detail')
            //     this.$set(this,'activeData',e)
            //     this.$set(this,'activeIndex',index)
            // }
            let self = this

            console.log('route 点击行',self.$route.params.activeNo)
            
            let path = this.rootNavbar.href 
            let root = this.rootNavbar.key 
            let active = self.$route.params.activeNo
            store.commit('setActiveNav',this.rootNavbar) 
            if(path == '/'){
                let to =  this.getNavBarData(this.no)
                path = to.href
                root = to.key 
                store.commit('setActiveNav',to) 
            }
            if(path && path.indexOf(':') !== -1){
                path = path.split(':')[0]
            }
            if(!path){
                let onItem = e
                path = onItem.category_no_path
                if(path){
                    path = path.split('/')
                    path = path.filter(item => item)
                    if(Array.isArray(path) && path.length > 1){
                        root = path[0]
                        path = 'homePage'

                        let navs = store.getters.getNavs
                        navs = this.getTree(navs,'key','parent_no',root)
                        if(navs.length == 1){
                            navs = navs[0]
                            store.commit('setActiveNav',navs)   
                        }
                    }
                }
            }
            this.$router.push(`/${path}/${root}/${e.category_no}/detail/${e.id}?source=list`)
            // this.$emit('on-item-change',e)
        },
        getListData(){
            if(this.no){
                let req = {
                    "serviceName": "srvdaq_pc_website_content_select",
                    "colNames": this.cols,
                    "condition": [{
                        colName:'category_no_path',
                        // colName:'category_no',
                        ruleType:'like',
                        value:`${this.no}`
                    }],
                    // "condition": [],
                    "relation_condition": {},
                    "page": {
                        "pageNo": this.currentPage,
                        "rownumber": this.rowspan
                    },
                    "order": [
                    {
                            "colName": "attribute",
                            "orderType": "desc"
                        },{
                            "colName": "create_time",
                            "orderType": "desc"
                        }
                    ],
                    "draft": false,
                    "query_source": "list_page"
                }
                let relation_Conditions={
                    "relation": "OR",
                    "data": []
                }
                if(this.currentPage == 1){
                    let relations = [{
                        "relation": "OR",
                        "data": [{
                            "colName":"attribute",
                            "ruleType":"in",
                            "value":"置顶"
                        }]
                    },{
                        "relation": "OR",
                        "data": [{
                            "colName":"title",
                            "ruleType":"like",
                            "value":""
                        }]
                    }]
                    relation_Conditions.data = relations
                    // req.relation_condition = relation_Conditions 
                }
                
                if(!this.layoutNo && this.initRequest){
                    req = this.initRequest
                }
                getContent(req).then((res) =>{
                     if(Array.isArray(res.data)){
                        // console.log('get data',res)
                        this.$set(this,'total',res.page.total)
                        this.listData = res.data.map(item => item)
                        if(Array.isArray(this.listData) && this.listData.length == 1){
                            this.$set(this,'activeData',this.listData[0])
                            this.$set(this,'activeMode','detail')
                        }
                     }
                })
                
            }else{
                console.log('使用初始化 条件')
                let req = null
                if(!this.layoutNo && this.initRequest){
                    req = this.initRequest
                    getContent(req).then((res) =>{
                        if(Array.isArray(res.data)){
                            // console.log('get data',res)
                            this.$set(this,'total',res.page.total)
                            this.listData = res.data.map(item => item)
                        }
                    })
                }
                
            }
        }
    },
    watch:{
        "currentPage":{
            deep:true,
            handler:function(nval,oval){
                this.getListData()
            }
        },
        "layoutNo":{
            deep:true,
            handler:function(nval,oval){
                if(nval !== oval){
                    this.$set(this,'currentPage',1)
                    this.toList()
                    this.getListData()
                }
                
            }
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.card-img{
  min-height: 8rem;
}
  </style>
  